export const getBrowserInfo = (userAgent: string) => {
  const ua = userAgent;
  let browser = 'Unknown';
  let version = 'Unknown';

  if (/firefox/i.test(ua)) {
    browser = 'Firefox';
    version = ua.match(/firefox\/(\d+\.\d+)/i)?.[1] || version;
  } else if (/chrome|crios/i.test(ua) && !/edge|edg|opr|opera/i.test(ua)) {
    browser = 'Chrome';
    version = ua.match(/(?:chrome|crios)\/(\d+\.\d+)/i)?.[1] || version;
  } else if (/safari/i.test(ua) && !/chrome|crios|edge|edg|opr|opera/i.test(ua)) {
    browser = 'Safari';
    version = ua.match(/version\/(\d+\.\d+)/i)?.[1] || version;
  } else if (/applewebkit/i.test(ua) && /iphone|ipad|ipod/i.test(ua) && !/chrome|crios|edge|edg|opr|opera/i.test(ua)) {
    browser = 'Safari (WebView)';
    version = ua.match(/applewebkit\/(\d+\.\d+)/i)?.[1] || version;
  } else if (/edg|edge/i.test(ua)) {
    browser = 'Edge';
    version = ua.match(/(?:edg|edge)\/(\d+\.\d+)/i)?.[1] || version;
  } else if (/opr|opera/i.test(ua)) {
    browser = 'Opera';
    version = ua.match(/(?:opr|opera)\/(\d+\.\d+)/i)?.[1] || version;
  }

  // Detect if running inside a known app (e.g., Facebook, Instagram, etc.)
  let appUsed: string | undefined;
  if (/FBAN|FBAV/i.test(ua)) {
    appUsed = 'Facebook';
  } else if (/Instagram/i.test(ua)) {
    appUsed = 'Instagram';
  } else if (/Line/i.test(ua)) {
    appUsed = 'Line';
  } else if (/WhatsApp/i.test(ua)) {
    appUsed = 'WhatsApp';
  } else if (/Twitter/i.test(ua)) {
    appUsed = 'Twitter';
  } else if (/Messenger/i.test(ua)) {
    appUsed = 'Messenger';
  } else if (/Snapchat/i.test(ua)) {
    appUsed = 'Snapchat';
  } else if (/TikTok/i.test(ua)) {
    appUsed = 'TikTok';
  }

  let os = 'Unknown';
  if (/windows nt/i.test(ua)) {
    os = 'Windows';
  } else if (/iphone|ipad|ipod/i.test(ua)) {
    os = 'iOS';
  } else if (/macintosh|mac os x/i.test(ua)) {
    os = 'macOS';
  } else if (/android/i.test(ua)) {
    os = 'Android';
  } else if (/linux/i.test(ua)) {
    os = 'Linux';
  }

  return { browser, version, app: appUsed, os };
};

export const getDeviceType = (userAgent: string) => {
  const ua = userAgent;
  if (/tablet|ipad/i.test(ua)) return 'tablet';
  if (/mobile/i.test(ua)) return 'mobile';
  return 'desktop';
};
